export default {
    install(Vue, options) {
        if (process.env.VUE_APP_PROJECT_ACS == 'true') {
            Vue.prototype.isACS = true;
        } else {
            Vue.prototype.isACS = false;
        }
    },
}